import styled from '@emotion/styled';
import { TextareaAutosize } from '@mui/material';
import classNames from 'classnames';
import { get } from 'lodash';
import React from 'react';
import { DebounceInput } from 'react-debounce-input';

const Styled = styled.div`
    margin-bottom: 24px;
    position: relative;
    padding: 0;
    height: 50px;

    &.isTextarea {
        height: auto !important;
        max-height: 250px;
        overflow-y: auto;
    }

    .input-container {
        margin-bottom: 0;
        display: flex;
        align-items: center;
        border-radius: 10px;
        gap: 5px;
        overflow: hidden;
        height: 100%;

        input[type='password'] {
            font-family: Verdana;
            font-weight: 700;
            letter-spacing: 0.125em;
        }

        input {
            max-height: 45px;
        }

        input,
        .textarea {
            padding: 15px 10px;
            flex: 1;
            height: 100%;
            border: none;
            outline: none;
            font-size: 14px;
            line-height: 30px;
            min-width: 0;
        }
        .textarea {
            resize: none;
        }
    }
    .error-message {
        color: #e00;
        display: block;
        position: absolute;
        top: calc(100% + 3px);
        left: 0;
        line-height: 1;
        font-size: 12px;
    }

    /*  */
    .label-top {
        color: #e00;
        display: block;
        position: absolute;
        top: calc(0% + -18px);
        left: 0;
        line-height: 1;
        font-size: 12px;
    }
    .label-top1 {
        color: black;
        display: block;
        position: absolute;
        top: calc(0% + -18px);
        left: 0;
        line-height: 1;
        font-size: 12px;
    }

    @media only screen and (max-width: 1536px) {
        height: 46px;
    }
`;

const CustomInput = ({
    name = '',
    labelTop = '',
    errors = {},
    showError = true,
    register = {},
    rightContent = null,
    style = {},
    messages = {},
    variant = 'input',
    className,
    ...rest
}) => {
    return (
        <Styled
            className={classNames('input ' + className, {
                error: get(errors, name),
                isTextarea: variant === 'textarea',
            })}
            style={style}
        >
            {get(errors, name) ? <div className="label-top">{labelTop}</div> : <div className="label-top1">{labelTop}</div>}
            <div className={'input-container'}>
                {variant !== 'textarea' ? (
                    variant === 'waiting' ? (
                        <DebounceInput
                            minLength={rest.minLength || 2}
                            debounceTimeout={rest.timeout || 300}
                            onWheel={(e) => e.currentTarget.blur()}
                            {...rest}
                        />
                    ) : (
                        <input onWheel={(e) => e.currentTarget.blur()} {...rest} {...register} />
                    )
                ) : (
                    <TextareaAutosize className="textarea" {...rest} {...register} />
                )}
                {rightContent}
            </div>
            {showError && get(errors, name) && (
                <div className="label error-message">{get(errors, name)?.message || messages[get(errors, name)?.type]}</div>
            )}
        </Styled>
    );
};

export default CustomInput;
